// global_functions.js

import axios from "axios";
import db from "../db";
import { apiFetch } from "./apiFetch";

/**
 * Syncs transformed attendance data to the remote server.
 * @param {Array} transformed - Array of attendance records already mapped/formatted.
 * @param {string} API_BASE_URL - The base URL of the API.
 * @returns {Object} - { success: boolean, message: string }
 */

// DOES THE ACTUAL SYNC
// export const handleSync = async (transformed, id) => {
//   const API_BASE_URL =
//     localStorage.getItem("saved_sett_api_url") || "http://localhost:5100";
//   if (!transformed || transformed.length === 0) {
//     return { success: false, message: "No transformed data to sync." };
//   }


//   try {
//     //* STEP 1: SEND DATA TO SERVER
//     await axios.post(
//       `${API_BASE_URL}/api/location/confirm`,
//       transformed
//     );
//     //* STEP 2: MARK AS POSTED IN INDEXEDDB
//     if (id === 0) {
//       //* Mark All pending records as posted****
//       await db.attendance.where('recordstatusid').equals(1).modify({ recordstatusid: 3 });
//     } else {
//       //* Mark only this specific record as posted
//       await db.attendance.update(id, { recordstatusid: 3 });
//     }
//     return { success: true, message: "Successfully synced to server!" };
//   } catch (err) {
//     console.error("Sync error:", err);
//     return { success: false, message: "Sync failed. Check server or network." };
//   }
// };

//262506
// DOES THE ACTUAL SYNC
export const handleSync = async (transformed, id, visit = false, visitFrom = "", visitTo="") => {
  const API_BASE_URL =
    localStorage.getItem("saved_sett_api_url") || "http://localhost:5100";
  if (!transformed || transformed.length === 0) {
    return { success: false, message: "No transformed data to sync." };
  }

  try {
    //* STEP 1: SEND DATA TO SERVER
    // When visit is true, wrap the payload as { entries, visit } so the
    // backend route can tell this apart from a normal call and write
    // TWO pschdly rows instead of one. When visit is false (the default,
    // used by every existing caller), the body shape stays exactly as
    // before — a plain array — so nothing else breaks.
    const body = visit ? { entries: transformed, visit: true, visitFrom, visitTo  } : transformed;
    // const body = visit
    // ? { entries: transformed, visit: true, visitFrom }
    // : returnedToAci
    //   ? { entries: transformed, visit: false, returnedToAci: true }
    //   : transformed;
      
    await axios.post(
      `${API_BASE_URL}/api/location/confirm`,
      body
    );
    //* STEP 2: MARK AS POSTED IN INDEXEDDB
    if (id === 0) {
      //* Mark All pending records as posted****
      await db.attendance.where('recordstatusid').equals(1).modify({ recordstatusid: 3 });
    } else {
      //* Mark only this specific record as posted
      await db.attendance.update(id, { recordstatusid: 3 });
    }
    return { success: true, message: "Successfully synced to server!" };
  } catch (err) {
    console.error("Sync error:", err);
    return { success: false, message: "Sync failed. Check server or network." };
  }
};
//* CHECKS IF SERVER IS REACHABLE
export const pingServer = async (API_BASE_URL) => {
  const url = `${API_BASE_URL}/api/ping`; // ensure HTTPS, SENDS GET/API/PING

  try {

    const response = await axios.get(url, {
      timeout: 6000,
      headers: {
        "Cache-Control": "no-cache",
        "Pragma": "no-cache",
      },
    });

    return response.status === 200;    // , RETURN TRUE IF SERVER RESPONDS WITH 200 AND FALSE IF ERROR
  } catch (error) {
    console.warn("Ping failed:", error.message);
    return false;
  }
};

export const fetchAddressFromCoordinates = async (latitude, longitude) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 60000); // 2-second timeout

  try {
    const response = await apiFetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`,
      { signal: controller.signal }
    );
    clearTimeout(timeout);

    const data = await response.json();
    return data.display_name || "Unknown location";
  } catch (error) {
    clearTimeout(timeout);
    throw new Error("Failed to fetch address.");
  }
};

export const getPublicIP = async () => {
  try {
    const response = await apiFetch("https://api.ipify.org?format=json", { timeout: 2000 });
    const data = await response.json();
    return data.ip || "";
  } catch (error) {
    console.warn("Failed to fetch public IP:", error.message);
    return "";
  }
};

export const getBrowserAndOS = () => {
  const ua = navigator.userAgent;

  // Detect browser
  let browser = "Unknown";
  if (ua.includes("Firefox/")) {
    browser = "Firefox";
  } else if (ua.includes("Edg/")) {
    browser = "Microsoft Edge";
  } else if (ua.includes("Chrome/") && !ua.includes("Edg/")) {
    browser = "Chrome";
  } else if (ua.includes("Safari/") && !ua.includes("Chrome/")) {
    browser = "Safari";
  } else if (ua.includes("OPR/") || ua.includes("Opera")) {
    browser = "Opera";
  }

  // Detect OS
  let os = "Unknown";
  if (ua.includes("Windows NT 10.0")) os = "Windows 10";
  else if (ua.includes("Windows NT 6.3")) os = "Windows 8.1";
  else if (ua.includes("Windows NT 6.1")) os = "Windows 7";
  else if (ua.includes("Mac OS X")) os = "macOS";
  else if (ua.includes("Android")) os = "Android";
  else if (ua.includes("iPhone") || ua.includes("iPad")) os = "iOS";
  else if (ua.includes("Linux")) os = "Linux";

  // Return as plain text
  return `Browser: ${browser}, OS: ${os}`;
}

// to know this employee which device use  it will give me a random number 
// so this nb will be fixed in csae we cjange our device this number will change even with same uid we use it in 
// visit page we put it fingerprint where visit saved 
export const getDeviceStationId = () => {
  let deviceId = localStorage.getItem("device_station_id");
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem("device_station_id", deviceId);
  }
  return deviceId;
};

// Detects whether the current browser session is running on a real
// phone (Android/iOS), based on the browser's own reported user agent.
// Not spoof-proof, but standard practice for this kind of check.
export const isRealPhone = () => {
  const ua = navigator.userAgent || "";
  return /Android|iPhone|iPad|iPod/i.test(ua);
};
// Finds all offline-saved (pending) records and pushes them to the server,
// marking them posted once synced. Meant to run automatically when
// connectivity returns.
let syncInProgress = false;

export const syncPendingRecords = async () => {
  if (syncInProgress) {
    console.log("[DEBUG] Sync already in progress, skipping duplicate call.");
    return;
  }
  syncInProgress = true;

  try {
    const pending = await db.attendance.where("recordstatusid").equals(1).toArray();
    if (!pending.length) return;
    await handleSync(pending, 0);
  } finally {
    syncInProgress = false;
  }
};